import { render, staticRenderFns } from "./AddOrEditB2BDiscount.vue?vue&type=template&id=50d98266"
import script from "./AddOrEditB2BDiscount.vue?vue&type=script&lang=js"
export * from "./AddOrEditB2BDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports